import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { Model } from '../../backendmodel';
import { DataBuildToolJobLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DataBuildToolJobLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {},
            parameters: '*'
        }
    }
})
export class DataBuildToolJobLinkedServiceAdapter extends LinkedServiceAdapter<DataBuildToolJobLinkedService> {

    protected modelConstructor(): new () => DataBuildToolJobLinkedService {
        return DataBuildToolJobLinkedService;
    }

    protected model(): IModel {
        return DataBuildToolJobLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(_linkedService: DataBuildToolJobLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        return linkedServiceResource;
    }
    
    protected async propertiesToModelAsync(_linkedServiceResource: Model.LinkedServiceResource, linkedService: DataBuildToolJobLinkedService): Promise<DataBuildToolJobLinkedService> {
        return linkedService;
    }
}